import React, { FC, useCallback } from 'react';
import { FieldsInfo } from 'components';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import styles from './IdsAndSecrets.module.scss';
import { useQuery } from '@redux-requests/react';
import { AppsConstants } from 'modules/userApps/store/constants';
import { generateAppSecret } from 'modules/userApps/store/actions';
import { t } from 'utils';
import appConfig from 'constants/appConfig';

const IdsAndSecrets: FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const {
    data: { sandboxSecret },
  } = useQuery({ type: AppsConstants.APP, requestKey: id });

  const handleGenereteSecret = useCallback(async () => {
    const result = await dispatch(generateAppSecret(id));
    if (!result) return t('errors.somethingWentWrong');
  }, [dispatch, id]);

  return (
    <section className={styles.root}>
      <h2 className={styles.title}>{t('app.id.and.secret')}</h2>
      <FieldsInfo
        id={id}
        secret={sandboxSecret}
        title={`${appConfig.environment || ''}.environment`}
        onGenerate={handleGenereteSecret}
        hasGenerateButton
      />
    </section>
  );
};

export default IdsAndSecrets;
